import { useMutation, useQueryClient } from "react-query";
import { useTokenQuery } from "../useTokenQuery";

export function useDeleteDisabledStatRuleForMarket() {
  const tokenQuery = useTokenQuery();
  const queryClient = useQueryClient();

  return useMutation(
    "create_disabled_stat_rule_for_market",
    (action) => {
      let apiUrl = process.env.REACT_APP_API_URI.trim();

      return fetch(`${apiUrl}/operator/market-stat-rule-disabled/delete`, {
        method: "delete",
        headers: new Headers({
          Authorization: "Bearer " + tokenQuery.data,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(action.rules),
      }).then((res) => res);
    },
    {
      enabled: !!tokenQuery.data,
      onSettled: (data, error, variables) => {
        queryClient.invalidateQueries(["events", variables.fixtureId]);
      },
      onSuccess: () => {
        // Likely have to update the events query with same update from mutatePricesForEvents
        // queryClient.setQueryData(["events", fixtureId], newEventsForFixture);
      },
    },
  );
}
